import React from 'react';
import Template from './temlate';
import { txtTypeEnum } from '../constants';
import PropTypes from 'prop-types';
import TempleteFooter from "../TempleteFooter";
//TODO : 修改参数
const Main = ({dataInfo,additionalUserInfo,useInfo,commentInfo,likeInfo}) => {
    // if (dataInfo?.txtType === txtTypeEnum.FORWARD) {
    //     return <ForwardTemplate {...props} dataInfo={dataInfo} />;
    // }
    // let changeTab = (dataInfo) => {
    //     window.open(`http://172.30.21.26:3002/mobile/news/circles/contentDetail?id=${dataInfo.id}&orgId=${dataInfo.orgId}&refreshId=circle_owner_list${dataInfo.orgId}&isCircle=true&isFull=0&immersion=true&ifengsp=1`, "_blank")
    // }
    return <div >
        <Template  footerChildren={
            <TempleteFooter dataInfo={dataInfo} commentInfo={commentInfo} likeInfo={likeInfo}/>
        } additionalUserInfo={additionalUserInfo} useInfo={useInfo} dataInfo={dataInfo} />
    </div>

};

Main.propTypes = {
    /**
     * 帖子详情信息
     */
    dataInfo: PropTypes.object.isRequired,
};

export default Main;
